import React from 'react';
import cn from 'classnames';

import CompanyLogo from '../../../components/companyLogo';
import { buildCppSubpageUrl, formatNumber } from '../../../utils';
import { CPP_SUBPAGES } from '../../../utils/constant';

class CompanyClusterHeaderTitle extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, subPageName, data, showClaimCompanyButton, pullLogoUp } = this.props;
    const {
      claimedCompany,
      isVerifiedByEmployer,
      desktopDevice,
      jobsCountForHeader,
      showJobsCount,
      companyReviewsPage,
      subheaderItems,
    } = data;
    const {
      companyLogo,
      overallScore,
      starRatingCssName,
      companyID,
      companyNameCPS,
      companyJobsCount,
      displayFlagOfCompanyJobsPage,
      companyLink,
    } = data.companyInfo;
    const imgWidthHeight = desktopDevice ? 120 : 92.16;
    const imgWidth = imgWidthHeight;
    const imgHeight = imgWidthHeight;
    const reviewsPageLink = subheaderItems.find((item) => item.title === 'Reviews');

    const goToCompanyReviewsPage = () => {
      if (reviewsPageLink && !companyReviewsPage) window.location.href = reviewsPageLink.link;
    };

    return (
      <div
        className={cn('company-header-container position-relative mb-36 mt-20 w-100', {
          'z-mt-36': !pullLogoUp,
        })}
      >
        <div className={cn('company-logo-placeholder z-ml-12 z-ml-md-0', {
          'neg-margin-top': pullLogoUp
        })}>
          <CompanyLogo
            className="clusterHeaderCompanyLogoImg"
            companyName={companyNameCPS}
            companyLogo={companyLogo}
            imgWidth={imgWidth}
            imgHeight={imgHeight}
            size="xxlarge"
          />
        </div>
        <div className="company-data-placeholder">
          {!showJobsCount && (
            <h1 className="company-cluster-header-title">
              {/* Note: the space after title below is required, DO NOT remove it. */}
              <span className="title">{title + ' '}</span>
            </h1>
          )}
          {showJobsCount && (
            <div>
              <h1 className="d-inline company-cluster-header-title">{title}</h1>
              <span className="d-inline company-cluster-header-title">{` - ${formatNumber(
                jobsCountForHeader ?? data?.companyInfoJobs?.totalJobs ?? 0
              )} Jobs`}</span>
            </div>
          )}

          <div className="company-score d-flex z-mt-5 flex-wrap gg-6">
            {overallScore && (
              <span className="smallGrey d-inline-flex align-items-center mr-2">
                {`Zippia Score ${overallScore}`}
                {starRatingCssName && (
                  <ul
                    className={`ratingStars m-0 ${starRatingCssName} ${
                      reviewsPageLink && !companyReviewsPage ? 'pointer' : ''
                    }`}
                    onClick={goToCompanyReviewsPage}
                  >
                    <li className="firstStarRated" />
                    <li className="secondStarRated" />
                    <li className="thirdStarRated" />
                    <li className="fourthStarRated" />
                    <li className="fifthStarRated" />
                  </ul>
                )}
              </span>
            )}
            {!!companyJobsCount &&
              displayFlagOfCompanyJobsPage &&
              subPageName !== CPP_SUBPAGES.JOBS && (
                <div className="smallGrey job-openings">
                  <a
                    href={buildCppSubpageUrl(companyLink, '', CPP_SUBPAGES.JOBS)}
                    className="alink"
                  >
                    Job Openings ({formatNumber(companyJobsCount)})
                  </a>
                </div>
              )}
          </div>

          {isVerifiedByEmployer ? (
            <button
              type="button"
              className="d-contents"
              onClick={() => (window.location.href = `/employer/signup/?companyID=${companyID}`)}
            >
              <div className="company-claim-container">
                <span className="claim-status-green-check">&#10004;</span>
                <span className="company-claim-status">Verified</span>
              </div>
            </button>
          ) : (
            showClaimCompanyButton && (
              <button
                type="button"
                className="d-contents"
                onClick={() => (window.location.href = `/employer/signup/?companyID=${companyID}`)}
              >
                <div className="company-claim-container">
                  <span className="claim-status-red-dot" />
                  <span className="company-claim-status">Claim This Company</span>
                </div>
              </button>
            )
          )}

          {claimedCompany && (
            <div
              className="update-company-profile"
              onClick={() => (window.location.href = `/employer/profile/${companyID}/`)}
            >
              <span className="update-company-profile-link">Update Company Profile</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CompanyClusterHeaderTitle;
